"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  mutation setUserPassword($password: String!) {
    setUserPassword(password: $password) {
      _id
    }
  }
`;
exports.default = query;
//# sourceMappingURL=setUserPassword.mutation.js.map